import { useQuery } from '@apollo/client';
import { WOUNDSCRIBE_PERMISSION_CHECK } from 'admission-consent/constants';
import { GetProvenanceByAgentTypeQuery } from 'admission-consent/Schema';
import { ConsentAccess } from 'woundscribe/types';

type ConsentExtension = { url: string; valueBoolean?: boolean | null };

type ProvenanceData =
  | {
      GetProvenanceByAgentType?: {
        extension?: ConsentExtension[] | null;
        previousEncounterProvenance?: {
          extension?: ConsentExtension[] | null;
        } | null;
      } | null;
    }
  | undefined;

// Fails closed: missing provenance, a missing extension, or an unanswered
// question all mean no consent.
export const getConsentAccess = (
  data: ProvenanceData,
  isLoading: boolean
): ConsentAccess => {
  let extensions: ConsentExtension[] = [];
  if (data?.GetProvenanceByAgentType) {
    const provenanceData = data.GetProvenanceByAgentType;
    if (provenanceData?.extension?.length) {
      extensions = provenanceData.extension;
    } else if (provenanceData?.previousEncounterProvenance?.extension?.length) {
      extensions = provenanceData.previousEncounterProvenance.extension;
    }
  }

  const consentExtension = extensions.find(
    (ext) => ext.url === WOUNDSCRIBE_PERMISSION_CHECK
  );

  return {
    hasConsent: consentExtension?.valueBoolean === true,
    isLoading,
  };
};

// Same provenance query and extension as EncounterLandingPage.
export function useWoundScribeConsent(
  patientId: string | undefined,
  encounterId: string | undefined,
  enabled: boolean
): ConsentAccess {
  const { data, loading } = useQuery(GetProvenanceByAgentTypeQuery, {
    fetchPolicy: 'network-only',
    skip: !enabled || !patientId || !encounterId,
    variables: { patientId, encounterId },
  });

  return getConsentAccess(data, loading);
}
